import * as Sentry from '@sentry/react';

import { createApiClientInstance, initApiClient } from '@cast/api-client';
import { client } from '@cast/core';

import { performLogout } from './logout';

export const { apiClient, middlewareController } = createApiClientInstance(
  client,
  {
    onUnauthorized: () => performLogout(),
    captureWarning: (message, extra) =>
      Sentry.captureMessage(message, { level: 'warning', extra }),
  }
);

initApiClient(apiClient);
